import React from 'react'
import { ListItem, ListItemIcon, ListItemText, IconButton } from '@mui/material'
import {
  AutoAwesomeTwoTone as AutoAwesomeIcon,
  MoreVert as MoreVertIcon,
} from '@mui/icons-material'

import type { Theme } from './ThemeKeyPhrasesModal/Types'
import { KeyPressEvent, ClickEvent } from '../Helpers/Helper'
import { useThemesListStyles } from './Hooks/UseThemeStyles'

interface ThemeListItemProps {
  theme: Theme
  isDeleteTheme: boolean
  onOpenThemeModal: (theme: Theme) => void
  onMenuClick: (e: ClickEvent | KeyPressEvent, theme: Theme) => void
}

const ThemeListItem: React.FC<ThemeListItemProps> = ({
  theme,
  isDeleteTheme,
  onOpenThemeModal,
  onMenuClick,
}) => {
  const styles = useThemesListStyles()

  return (
    <ListItem
      key={theme.id}
      aria-label={`View key phrases for theme ${theme.attributes.name}`}
      tabIndex={0}
      onClick={() => onOpenThemeModal(theme)}
      onKeyDown={(e: KeyPressEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onOpenThemeModal(theme)
        }
      }}
      secondaryAction={
        <IconButton
          edge="end"
          aria-label={`Options for ${theme.attributes.name}`}
          aria-haspopup="true"
          onClick={(e) => onMenuClick(e, theme)}
          onKeyDown={(e: KeyPressEvent) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              onMenuClick(e, theme)
            }
          }}
          tabIndex={0}
          data-testid={`theme-list-item-${theme.id}`}
        >
          <MoreVertIcon />
        </IconButton>
      }
      sx={{
        ...styles.listItem,
        ...(isDeleteTheme && styles.deleteListItem),
      }}
    >
      <ListItemIcon>
        <AutoAwesomeIcon color="primary" />
      </ListItemIcon>
      <ListItemText primary={theme.attributes.name} />
    </ListItem>
  )
}

export default ThemeListItem
